/**
 * Strip ANSI escape sequences from terminal output.
 * Handles SGR (colors/styles), CSI (cursor movement), OSC (title), and other sequences.
 * Used to clean SSH PTY output before sending to TTS or summarization.
 */
// eslint-disable-next-line no-control-regex
const ANSI_RE = /\x1b(?:\[[0-9;?]*[a-zA-Z]|\].*?(?:\x07|\x1b\\)|\([A-Z0-9]|[>=<78HM])/g;

/** Common shell prompt patterns to strip (bash/zsh/fish) */
const PROMPT_RE = /^(?:\S+@\S+[:\$#>~]\s?|[$#>%]\s)/gm;

export function stripAnsi(text: string): string {
  return text.replace(ANSI_RE, '');
}

/**
 * Clean terminal output for TTS: strip ANSI, prompts, and excess whitespace.
 */
export function cleanTerminalForTTS(text: string): string {
  return stripAnsi(text)
    .replace(PROMPT_RE, '')
    .replace(/\r\n/g, '\n')
    .replace(/\r/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
